import type { RoomView } from "@grundbesitz/shared";
import { nameOf } from "../../lib/gameView";
import { useStore } from "../../lib/store";

/**
 * Reactions as short-lived bubbles on phones, where the player list is hidden in a sheet.
 * On desktop the reactions float at the player in the list instead.
 */
export function ReactionBubbles({ room }: { room: RoomView }) {
  const reactions = useStore((s) => s.reactions);
  if (reactions.length === 0) return null;
  return (
    <ul className="pointer-events-none fixed right-2 top-16 z-30 flex flex-col items-end gap-1 lg:hidden" aria-label="Reaktionen">
      {reactions.slice(-4).map((r) => (
        <li key={r.id} className="flex items-center gap-1.5 rounded-full border border-line bg-surface px-3 py-1 text-sm shadow-md">
          <span className="text-ink-2">{nameOf(room.game, room.members, r.playerId)}</span>
          <span className="text-xl" aria-label={`Reaktion ${r.emoji}`}>
            {r.emoji}
          </span>
        </li>
      ))}
    </ul>
  );
}
